// Modules switched off (code and data kept). Set a flag to false to bring a module back.
export const DISABLED_MODULES = {
  amazon: true,
  salesdesk: true,
  presentations: true, // ZKTeco Presentation, Customer Presentation & shared presentation links
};

const DISABLED_PATHS = [
  DISABLED_MODULES.amazon && "/amazon",
  DISABLED_MODULES.salesdesk && "/ai-salesdesk",
  DISABLED_MODULES.presentations && "/presentation",
].filter(Boolean);

export const isDisabledPath = (pathname) => {
  const p = (pathname || "").toLowerCase();
  return DISABLED_PATHS.some((d) => p === d || p.startsWith(`${d}/`) || p.startsWith(`${d}-`));
};
